<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="impression.id === null">{{ 'NEWIMPRESSION' | translate }}</span>
            <span *ngIf="impression.id !== null">{{ 'EDITIMPRESSION' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="impressionForm" id="impressionForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="impressionForm" >
            <input type="hidden" name="id" id="impressionId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="impressionVisitId" [autoDisplayFirst]="false" formControlName="visit" [options]="impressionsColumnsService.visits" optionValue="id" optionLabel="ip" [required]="false" [filter]="true"></p-dropdown>
                      <label for="impressionVisitId" class="">{{ 'VISIT' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="impressionBannerId" [autoDisplayFirst]="false" formControlName="banner" [options]="impressionsColumnsService.banners" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="impressionBannerId" class="req">{{ 'BANNER' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="impressionForm.controls['banner'].invalid && (impressionForm.controls['banner'].dirty || impressionForm.controls['banner'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="impressionForm.controls['banner'].errors !== null">
                  <div *ngIf="impressionForm.controls['banner'].errors.required">
                   {{ 'BANNERREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKIMPRESSIONS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="impression.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!impressionForm.valid || disableSubmit"> <!--  [disabled]="impressionForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!impressionForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

